module.exports = "../../app/cells/pages/question/question_suggestion/filter_questions.erb";